export default {
  modalStyle: {'display': 'none'},
  accumulatedPoints: {},
  starAccumTextContainer: {},
  starAdvantagesTitle: {},
  starAdvantagesContainer: {},
  advantageIcon:{},
  modalStContainer: {
    padding: '30px 10px',
    maxWidth: '450px',
    margin: '0 auto',
  },
  contentSTModal:{
    maxWidth: '600px',
    margin: '0 auto',
    background: '#fff',
    position: 'relative'
  },
  closeBtnStModal:{
    top: '15px',
    float: 'right',
    right: '15px',
    cursor: 'pointer',
    border: '0',
    zIndex: '600',
    position: 'absolute',
    fontSize: '15px',
    background: 'none',
    color: '#847648',
    '@media(min-width:801px)': {      
      fontSize: '20px',
    },
  },
  starLogo: { 
    width: '50%',
    margin: '0 auto' 
  },  
  modalTitle: {
    textAlign: 'center',
    color: '#847648',
    font: '15px "Roboto", serif',
    textTransform: 'uppercase',
    display: 'block',
    marginTop: '20px',
    '@media(min-width:801px)': {      
      fontSize: '20px',
    },
  },
  modalSubTitle: {
    display: 'block',
    marginTop: '15px',
    textAlign: 'center',
    font: '13px "Roboto", sans-serif',
    '@media(min-width:801px)': {
      fontSize: '16px',
    },
  },
  btnsContainer:{
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    marginTop: '20px',
    '@media(min-width:801px)': {
      fontSize: '16px',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'unset',
    },
  },
  buttonInterest: {
    display: 'block',
    backgroundColor: '#847648',
    padding: '10px 20px',
    color: '#fff',
    font: '600 11px "Roboto", sans-serif',
    letterSpacing: '0.7px',
    textTransform: 'uppercase',
    '@media(min-width:801px)': {
      fontSize: '16px',
      padding: '15px 40px',
    },
  },
  ButtonNoInterest: {    
    font: '12px "Roboto", sans-serif',
    textDecoration: 'underline',
    '@media(min-width:801px)': {
      marginTop: '10px',
      fontSize: '14px',
    },
  },
  blueTierColor: {},
  silverTierColor: {},
  starAccumPointsContainer:{
    //Change all this colors for the one corresponding to the type of star traveler
    marginTop: '20px',
    padding: '20px',
    font: '500 14px "Roboto", sans-serif',
    borderWidth: '4px 1px 1px 1px',
    textAlign: 'left',
    borderStyle: 'solid',
    background: '#fff',    
    borderColor: data => data.STgoldTier,
    '&$blueTierColor': {
      borderColor: data => data.STblueTier,
    },
    '&$silverTierColor': {
      borderColor: data => data.STsilverTier,
    },
    '& $accumulatedPoints': {
      fontSize: '24px',
      fontWeight: '500',
      color: data => data.STgoldTier,
      '&$blueTierColor': {
        color: data => data.STblueTier,
      },
      '&$silverTierColor': {
        color: data => data.STsilverTier,
      },
    },
    '& $starAccumTextContainer': {
      paddingBottom: '10px',
      borderBottom: data => `1px solid ${data.STgoldTier}`,
      '&$blueTierColor': {
        borderColor: data => data.STblueTier,
      },
      '&$silverTierColor': {
        borderColor: data => data.STsilverTier,
      },
    },
    '& $starAdvantagesTitle': {
      display: 'block',
      margin: '10px 0',
      color: data => data.STgoldTier,
      fontWeight: '500',
      fontSize: '14px',
      textTransform: 'uppercase',
      '&$blueTierColor': {
        color: data => data.STblueTier,
      },
      '&$silverTierColor': {
        color: data => data.STsilverTier,
      },
      ' > div':{
        display: 'flex',
      }
    },
    '& $starAdvantagesContainer': {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',gap: '10px',
      '& span':{
        display: 'flex',
        alignItems: 'center',
        '& $advantageIcon': {
          width: '22px',
          height: '22px',
          marginRight: '10px',
          fill: data => data.STgoldTier,
          '&$blueTierColor': {
            fill: data => data.STblueTier,
          },
          '&$silverTierColor': {
            fill: data => data.STsilverTier,
          },
        },
      }
    }
  },
  textwrapper: {
    '@media(min-width:600px) and (max-width:900px)': {
      display: 'inline-block',
      paddingRight: '5px',
    },
  },
  benefitIconContainer:{},
  benefitText:{},
}